import ExternalOrderPaymentModal from './ExternalOrderPaymentModal'

export default ExternalOrderPaymentModal
